import React, { useEffect, useState, useContext, useMemo, memo } from 'react'
import { Row, Col, Typography, Button, message, Tooltip, Switch } from "antd";
import { useParams, Link } from "react-router-dom";
import konsole from '../../network/konsole';
import Services from '../../network/Services';
import commonLib from '../../control/commonLib';
import moment from "moment";
import { UserContext } from '../../App';
import ToggleButton from '../ToggleButton';
import '../ToggleButton.css';
import './PublishedSeminar.css'
import Modal from 'react-bootstrap/Modal';
import QRCode from "react-qr-code";
import config from '../../config.json'
import { isNullUndefine, isValidFuntion } from '../../control/Constant';
import { BASE_URL, EVENTFUNNELURL } from '../../network/url';


const { Title, Text } = Typography;


const SeminarCard = memo(function SeminarCard({
    seminarObj,
    pastSeminar,
    showLess,
    readMoreProfile,
    onToggleStatus,
    onEdit,
    onCopySubtenant,
    onCopySubtenants,
    onShowQr,
    onShowFullProfile,
    onShowLess,
    filterSpeakerDescriptionLegth,
}) {

    const speakerNames = seminarObj.speakers?.length > 0
        ? seminarObj.speakers.map((speaker, index) => {
            const fName = (speaker.fName !== null && speaker.fName !== '') ? speaker.fName : '';
            const mName = (speaker.mName !== null && speaker.mName !== '') ? speaker.mName : '';
            const lName = (speaker.lName !== null && speaker.lName !== '') ? speaker.lName : '';
            return `${fName} ${mName} ${lName}`.trim();
        }).join(', ')
        : '';

    return (
        <div style={{ border: "2px solid #F0F0F0", borderRadius: "6px", marginBottom: "24px", overflow: "hidden" }}>

            {/* ── Header ── */}
            <div style={{ background: "linear-gradient(to right, #4A0311, #AA223A)", padding: "14px 18px" }}>
                <div className="d-flex justify-content-between align-items-start">
                    <div>
                        <div className="d-flex align-items-center gap-3" style={{ flexWrap: "wrap" }}>
                            <Title level={3} style={{ color: "#fff", marginBottom: 0, fontWeight: 700 }}>
                                {seminarObj.seminarTopic}
                            </Title>
                            {seminarObj.subtenantId !== 26 && (
                                                    <>
                                                        <Tooltip title="Edit">
                                                            <img src="./edit.svg" className="ms-2" style={{ cursor: "pointer", filter: "brightness(0) invert(1)", width: 18 }} onClick={() => onEdit(seminarObj)} />
                                                        </Tooltip>
                                                        {pastSeminar == "Present" && (
                                                        <Tooltip title="Duplicate">
                                                            <img src="./content_copy.svg" className="ms-1" style={{ cursor: "pointer", filter: "brightness(0) invert(1)", width: 18 }} onClick={() => onEdit(seminarObj, "currentFuture")} />
                                                        </Tooltip>
                                                        )}
                                                        {pastSeminar !== "Present" && (
                                                        <Tooltip title="Duplicate">
                                                            <img src="./content_copy.svg" className="ms-1" style={{ cursor: "pointer", filter: "brightness(0) invert(1)", width: 18 }} onClick={() => onEdit(seminarObj)} />
                                                        </Tooltip>
                                                        )}
                                                    </>
                                                )}
                        </div>
                        <div style={{ color: "#fff", fontSize: "14px", marginTop: 4 }}>
                            By {speakerNames}
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-2" style={{ flexShrink: 0 }}>
                        {seminarObj.subtenantId !== 26 && (
                            <>
                                <span style={{ border: "2px solid #D9D9D9", borderRadius: "20px", color: "#720C20", padding: "2px 14px", fontSize: "13px", backgroundColor:"#FFF0F0"}}>
                                    {seminarObj.seminarType}
                                </span>
                                <span style={{ border: "2px solid #D9D9D9", borderRadius: "20px", color: "#720C20", padding: "2px 14px", fontSize: "13px", backgroundColor:"#FFF0F0" }}>
                                    {seminarObj.isSeminarPaid ? `Paid${seminarObj.seminarFee ? ` : $${seminarObj.seminarFee}` : ''}` : 'Free'}
                                        </span>
                            </>
                        )}
                        {pastSeminar == "Present" && (
                            <Switch style={{border:"2px solid #FFF0F0"}} checkedChildren="Show" onChange={(e) => onToggleStatus(e, seminarObj)} unCheckedChildren="Hide" defaultChecked={seminarObj.isActive} />
                        )}
                        {seminarObj.subtenantId == 26 && (
                            <button type="button" className="btn btn-outline-light btn-sm">Register Now</button>
                        )}
                    </div>
                </div>
            </div>

            {/* ── Date / Venue / Location row ── */}
            <div style={{ borderBottom: "1px solid #dee2e6", padding: "12px 20px", backgroundColor: "#fff" }}>
                <div className="d-flex justify-content-between" style={{ gap: "32px", flexWrap: "wrap" }}>
                    {/* Date */}
                    <div className="d-flex align-items-start gap-2">
                        <img src="/images/Frame101.svg" alt="date" style={{ width: 28, marginTop: 2, flexShrink: 0 }} />
                        <div>
                            <div style={{ fontSize: "13px", color: "#555", fontWeight: 600 }}>Date</div>
                            <div style={{ fontSize: "14px", color: "#222" }}>
                                {commonLib.getFormattedDate(seminarObj.seminarDate)}, at {commonLib.getFormattedTime(seminarObj.seminarTime)}
                            </div>
                        </div>
                    </div>

                    {/* Venue */}
                    {seminarObj.seminarTypeId == 46 && seminarObj.seminarVenue && (
                        <div className="d-flex align-items-start gap-2">
                            <img src="/images/Frame102.svg" alt="venue" style={{ width: 28, marginTop: 2, flexShrink: 0 }} />
                            <div>
                                <div style={{ fontSize: "13px", color: "#555", fontWeight: 600 }}>Venue</div>
                                <div style={{ fontSize: "14px", color: "#222" }}>{seminarObj.seminarVenue}</div>
                            </div>
                        </div>
                    )}

                    {/* Location */}
                    {seminarObj.seminarTypeId == 46 && seminarObj.venueAddressLine1 && (
                        <div className="d-flex align-items-start gap-2">
                            <img src="/images/Frame102.svg" alt="location" style={{ width: 28, marginTop: 2, flexShrink: 0 }} />
                            <div>
                                <div style={{ fontSize: "13px", color: "#555", fontWeight: 600 }}>Location</div>
                                <div style={{ fontSize: "14px", color: "#222" }}>{seminarObj.venueAddressLine1}</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* ── Body ── */}
            <div style={{ padding: "14px 18px", backgroundColor: "#fff" }}>
                {(seminarObj?.subtenantId !== 26) ? (
                    <>
                        {/* About Seminar */}
                        <div style={{ borderBottom: "1px solid #dee2e6", paddingBottom: 12, marginBottom: 8 }}>
                            <div style={{ fontWeight: 700, fontSize: "15px", marginBottom: 4 }}>About Seminar</div>
                            <Text className="fs-6">{seminarObj.description}</Text>
                        </div>

                        {/* Speakers */}
                        <div style={{ borderBottom: "1px solid #dee2e6", paddingBottom: 12, marginBottom: 10 }}>
                            <div style={{ fontWeight: 700, fontSize: "15px", marginBottom: 10 }}>
                                {seminarObj.speakers?.length > 1 ? "Speakers" : "Speaker"}
                            </div>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "16px", alignItems: "flex-start" }}>
                                {seminarObj.speakers?.length > 0 && seminarObj.speakers.map((items, ind) => {
                                    const isExpanded = (readMoreProfile == items?.speakerUserId) && showLess == true;
                                    const hasLongProfile = items?.speakerProfile?.length > 150;
                                    return (
                                        <div
                                            key={ind}
                                            style={{
                                                border: "2px dashed #720C20",
                                                borderRadius: "8px",
                                                padding: "16px 12px",
                                                width: isExpanded ? "100%" : "240px",
                                                height: isExpanded ? "auto" : "210px",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                textAlign: "center",
                                                boxSizing: "border-box",
                                                overflow: "hidden"
                                            }}
                                        >
                                            {/* Profile Image */}
                                            <img
                                                src={
                                                    items?.speakerProfileUrl !== null &&
                                                    items?.speakerProfileUrl !== undefined &&
                                                    items?.speakerProfileUrl !== ""
                                                        ? items?.speakerProfileUrl
                                                        : "/images/profileDummy.svg"
                                                }
                                                alt=""
                                                style={{
                                                    width: "72px",
                                                    height: "72px",
                                                    borderRadius: "50%",
                                                    objectFit: "cover",
                                                    marginBottom: "10px",
                                                    backgroundColor: "#e0e0e0",
                                                    flexShrink: 0
                                                }}
                                            />
                                            {/* Name */}
                                            <div style={{ fontWeight: 600, fontSize: "14px", marginBottom: "8px", flexShrink: 0 }}>
                                                {`${items?.fName || ""} ${items?.mName || ""} ${items?.lName || ""}`.trim()}
                                            </div>
                                            {/* Description */}
                                            {items?.speakerProfile && (
                                                <div style={{
                                                    fontSize: "13px",
                                                    color: "#444",
                                                    textAlign: isExpanded ? "left" : "center",
                                                    marginBottom: "6px",
                                                    flex: 1,
                                                }}>
                                                    {isExpanded
                                                        ? items?.speakerProfile
                                                        : hasLongProfile
                                                            ? `${items?.speakerProfile?.substr(0, 50)}...`
                                                            : items?.speakerProfile
                                                    }
                                                </div>
                                            )}
                                            {/* Read More / Show Less */}
                                            {isExpanded ? (
                                                <a
                                                    onClick={onShowLess}
                                                    style={{ color: "#720C20", fontWeight: 600, cursor: "pointer", fontSize: "13px", textDecoration: "none", flexShrink: 0 }}
                                                >
                                                    Show Less
                                                </a>
                                            ) : hasLongProfile ? (
                                                <a
                                                    onClick={() => onShowFullProfile(items, ind, seminarObj.speakers)}
                                                    style={{ color: "#720C20", fontWeight: 600, cursor: "pointer", fontSize: "13px", textDecoration: "none", flexShrink: 0 }}>
                                                    Read More
                                                </a>
                                            ) : null}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        {/* URLs */}
                        <Row className="align-items-center">
                                <Col span={24} className="mb-1 d-flex justify-content-between">
                                    <h6>Leadstacker URL</h6>
                                    <h6 style={{ marginRight: "55px" }}>Event URL</h6>
                                    <div style={{ width: 35 }} />
                                </Col>
                                <Col span={24} className="mb-1 d-flex justify-content-between">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <Text className="fs-6 border border-2 ps-3 pe-2 pt-1 pb-1" style={{ borderColor: "#474747 !important" }}>
                                            <span className='pe-2 border-end border-2' style={{ borderColor: "#474747" }}>{BASE_URL}/api/2/.....</span>
                                            <Tooltip title="Copy">
                                                <span className='ps-1'><img className='pb-1 ps-1' onClick={() => onCopySubtenants(seminarObj)} style={{ cursor: 'pointer' }} src='/icons/icon-park-outline_copy-link.svg' width={25} /></span>
                                            </Tooltip>
                                        </Text>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <Text className="fs-6 border border-2 ps-3 pe-2 pt-1 pb-1" style={{ borderColor: "#474747" }}>
                                            <span className='pe-2 border-end border-2' style={{ borderColor: "#474747" }}>{EVENTFUNNELURL}/eventlisting/{seminarObj.subtenantId}/{seminarObj?.seminarId}</span>
                                            <Tooltip title="Copy">
                                                <span className='ps-1'><img className='pb-1 ps-1' onClick={() => onCopySubtenant(seminarObj)} style={{ cursor: 'pointer' }} src='/icons/icon-park-outline_copy-link.svg' width={25} /></span>
                                            </Tooltip>
                                        </Text>
                                    </div>
                                    <div>
                                        <div className='w-100 d-flex justify-content-end m-0 p-0' style={{ maxWidth: 35, width: "100%" }} id='qr-gen'>
                                            <QRCode
                                                size={256}
                                                style={{ height: "auto", width: "100%", cursor: "pointer" }}
                                                value={`${EVENTFUNNELURL}/eventlisting/${seminarObj.subtenantId}/${seminarObj?.seminarId}`}
                                                viewBox={`0 0 256 256`}
                                                onClick={() => onShowQr(`${EVENTFUNNELURL}/eventlisting/${seminarObj.subtenantId}/${seminarObj?.seminarId}`)}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </>
                    ) : (
                            <Row>
                                <Col span={4} xs={24} sm={24} md={4} lg={4} xl={3} className="m-0 mb-2 me-sm-3">
                                    <div className='eventListingImage'>
                                        <img src='/icons/rajivSpeakerImage.jpeg' />
                                    </div>
                                </Col>
                                <Col xs={24} md={19} className="p-0 m-0 me-1">
                                    <Text className="fs-6">
                                        70% of Americans not being able to live out their lives at home should be as much of an outrage as racism, gender discrimination, child abuse, etc.  BUT IT IS NOT.<br />
                                        Seniors are not cute and cuddly.<br />
                                        This, as you know, has been my life's MISSION. To change the way we think of, plan for, and navigate through retirement.  And I need your support and help to tear down the walls that keep sunlight out of lives of the retired community members.<br />
                                        I am inviting a handful of my over 7,000 clients to share what I have been able to accomplish, and what I feel is needed as the next step to finally break down the walls.  And ask for your time and help that will also allow you to leave a sound legacy to be proud of – changing lives of retirees.<br />
                                    </Text>
                                </Col>
                            </Row>
                        )}
            </div>
        </div>
    );
});


const PublishedSeminar = (props) => {
    const { setLoader } = useContext(UserContext)
    const [seminardata, setSeminardata] = useState([])
    const [toggledata, setToggledata] = useState()
    const [imageUrl, setImageUrl] = useState('');
    const [text, setText] = useState('');
    const [show, setShow] = useState(false);
    const [NewStatee, setNewStatee] = useState([])
    const [showLess, setShowLess] = useState(false)
    const [readMoreProfile, setReadMoreProfile] = useState(null)
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [toggleButton, setToggleButton] = useState(true);
    const [selecteDate, setSelectedDate] = useState()

    const handleClose = (val) => {
        setShow(false);
    }
    const formatToYYYYDDMM = (input) => {
        const d = new Date(input);
        if (isNaN(d)) return "";
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const dd = String(d.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
    };


    const handleShow = (val) => {
        setNewStatee(val)
        setShow(true);
    }

    const isFutureDate = (date) => {
        if (!date) return false;
        const selected = new Date(date);
        const now = new Date();
        now.setHours(0, 0, 0, 0);
        return selected > now;
    };
    const isInvalidYear = (date) => {
        const year = date.split("-")[0];
        return Number(year) < 1500;   // change 1900 if needed
    };
    const getLocalISO = () => {
        const d = new Date();
        const tzOffset = d.getTimezoneOffset() * 60000;
        const localISO = new Date(d - tzOffset).toISOString().slice(0, -1);
        return localISO;
    };


    const today = useMemo(() => {
        const today = getLocalISO()
        const todayCurrentDate = new Date(today)
        todayCurrentDate.setDate(todayCurrentDate.getDate() - 1)
        return formatToYYYYDDMM(todayCurrentDate);
    }, []);


    const subtenantId = commonLib.getSessionStoarge('subtenantId')
    const showFullProfile = (items, index, speakers1) => {
        setReadMoreProfile(items?.speakerUserId)
        let setAtZero = [];
        let filterData = [];
        filterData = speakers1.splice(index, 1);
        setAtZero = speakers1.unshift(items);
        setShowLess(true)
    }


    useEffect(() => {
        generateQrCode();
        setText(`${EVENTFUNNELURL}/eventlisting/${subtenantId}`)
    }, [subtenantId])



    const getCurrentMonthValue = (date) => {
        const now = new Date(date);
        return `${now.getFullYear()}-${now.getMonth()}`;
    };


    useEffect(() => {
        const isActive = true;
        if (props.pastSeminar === "Present") {
            getSeminar('', isActive, getLocalISO(), null);
        } else {
            pastSeminarfunc()
        }
        if (isNullUndefine(selecteDate)) {
            setSelectedDate(getCurrentMonthValue(getLocalISO()))
        }
    }, [props.pastSeminar]);


    const getSeminar = (subtenantId, isActive, startDate, endDate) => {
        let userroleid = JSON.parse(sessionStorage.getItem("stateObj"))?.roleId;
        let subtenantid = commonLib.getSessionStoarge('subtenantId')
        let foradminrole = false;
        if (userroleid != "4") {
            foradminrole = true;
        }
        setLoader(true)
        let promise = Services.getSeminarDataNew(subtenantid, startDate, endDate, null)
        promise.then((res) => {
            setSeminardata(res?.data?.data)
            setLoader(false)
        }).catch((err) => {
            setSeminardata([])
        }).finally(() => {
            setLoader(false)
        })
    }




    const copysubtenant = (e) => {
        var text = `${EVENTFUNNELURL}/eventlisting/${e?.subtenantId}/${e?.seminarId}`
        navigator.clipboard.writeText(text).then(_ => {
            message.success('Copied successfully!')
        })
    }
    const copysubtenants = (e) => {
        var text = `${BASE_URL}/api/2/User/LeadstackerRegisterUserAsync/${e?.seminarId}/${e?.subtenantId}?firstName={{contact.first_name}}&lastName={{contact.last_name}}&phone={{contact.phone}}&email={{contact.email}}&noOfAttendees={{contact.number_of_attendes}}&source={{contact.how_did_you_hear_about_this_event}}`
        navigator.clipboard.writeText(text).then(_ => {
            message.success('Copied successfully!')
        })
    }
    const filterSpeakerDescriptionLegth = (dataSpeakerProfile) => {
        return dataSpeakerProfile.substr(0, 100);
    };


    const toggledatafun = (e, seminarObj) => {
        const loggedInUser = commonLib.getObjFromStorage('stateObj');
        setLoader(true);
        Services.upsertSeminarStaus(seminarObj.seminarId, e, loggedInUser.userId)
            .then(res => {
                setLoader(false);
                if (props.pastSeminar === "Present") {
                    getSeminar('', true, getLocalISO(), null);
                } else {
                    getSeminar('', true, fromDate, toDate);
                }
            })
            .catch(error => {
                setLoader(false);
            }).finally(() => {
                setLoader(false);
            })
    }


    const generateQrCode = async () => {
        try {
            const response = await QRCode.toDataURL(text);
            setImageUrl(response);
        } catch (error) {
            konsole.log(error);
        }
    }


    const filteredSeminars = useMemo(() => {
        const currValue = props?.searchseminar || "";
        return seminardata?.filter((entry) =>
            entry.seminarTopic.toLowerCase().includes(currValue.toLowerCase())
        );
    }, [props.searchseminar, seminardata]);

    const returnfunforQR = (subtenant) => {
        return subtenant
    }

    const EditDataSendToSeminar = (particularData, state) => {
        if (state === "currentFuture") {
            particularData[state] = true
        }
        props.setEditFuncData(particularData)
        props.setEditFuncData2(particularData)
        props.setChangeBorderToTopButtons(1)
        props.setPublishSeminar(true)
    }
    const urlFunc = () => {
        return `${BASE_URL}/api/2/User/LeadstackerRegisterUserAsync/${""}/${""}?firstName={contact.first_name}}&lastName={{contact.last_name}}&phone={{contact.phone_dummy_3}}&email={{contact.email}}`
    }


    const handleToDateChange = (e) => {
        const value = e.target.value;
        if (isFutureDate(value)) {
            setToDate('')
            e.target.blur();
            return
        }
        if (fromDate && new Date(value) < new Date(fromDate) && isInvalidYear(value) == false) {
            setToDate('')
            e.target.blur();
            return
        };

        setToDate(value);

        if (!isNullUndefine(fromDate) && isInvalidYear(value) == false) {
            getSeminar('', true, fromDate, value);
        }

        e.target.blur();
    };


    const isValidDateFormat = (value) => {
        return /^\d{4}-\d{2}-\d{2}$/.test(value);
    };


    const pastSeminarfunc = (event) => {
        setToggleButton(!toggleButton);
        const today = getLocalISO()
        if (props.pastSeminar == "past") {
            const todayCurrentDate = new Date(today)
            todayCurrentDate.setDate(todayCurrentDate.getDate() - 1)
            const lastYearDate = new Date(todayCurrentDate)
            lastYearDate.setFullYear(lastYearDate.getFullYear() - 1)
            setToDate(formatToYYYYDDMM(todayCurrentDate));
            setFromDate(formatToYYYYDDMM(lastYearDate))
            getSeminar('', true, formatToYYYYDDMM(lastYearDate), formatToYYYYDDMM(todayCurrentDate));
        } else {
            getSeminar('', true, today, null);
        }
    };


    const handleFromDateChange = (e) => {
        const value = e.target.value;
        if (!isValidDateFormat(value)) return;
        if (isFutureDate(value)) {
            setFromDate('')
            e.target.blur();
            return
        }

        if (toDate && new Date(value) > new Date(toDate) && isInvalidYear(value) == false) {
            setFromDate('')
            e.target.blur();
            return
        };

        setFromDate(value);

        if (!isNullUndefine(toDate) && isInvalidYear(value) == false) {
            getSeminar('', true, value, toDate);
        }

        e.target.blur();
    };



    return (
        <>
            {props.pastSeminar == "past" ? (
            <div className='d-flex justify-content-between px-1 mt-3 mb-3' style={{ gap: "24px", flexWrap: "wrap" }}>
                <Title level={2} className="Modal-Retire-Life-Tag mb-0" style={{ color: "#720C20", whiteSpace: "nowrap" }}>Past Seminars</Title>

                  <div className="d-flex align-items-center" style={{ gap: "12px" }}>
                        <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                            <label htmlFor="seminarFromDate" style={{ fontSize: "14px", color: "#6c757d", fontWeight: "700", marginBottom: 0, whiteSpace: "nowrap" }}>From</label>
                        <input
                            id="seminarFromDate"
                            type="date"
                            value={fromDate}
                            max={toDate || today}
                            onChange={handleFromDateChange}
                            style={{ width: "160px", padding: "6px 10px", borderRadius: "4px", border: "1px solid #ced4da", cursor: "pointer" }}
                        />
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                        <label htmlFor="seminarToDate" style={{ fontSize: "14px", color: "#6c757d", fontWeight: "700", marginBottom: 0, whiteSpace: "nowrap" }}>To</label>
                        <input id="seminarToDate" type="date" value={toDate} max={today}
                            min={fromDate || ""}
                            onChange={handleToDateChange}
                            style={{ width: "160px", padding: "6px 10px", borderRadius: "4px", border: "1px solid #ced4da", cursor: "pointer" }}
                        />
                        </div>
                    </div>
                </div>
            ) : (
                <div className='d-flex justify-content-between align-items-center px-1 mt-2 mb-2'>
                    <Title level={2} className="Modal-Retire-Life-Tag mt-4" style={{ color: "#720C20" }}>Upcoming Seminars</Title>
                </div>
            )}


            <div style={{paddingLeft: "0px", paddingRight: "0px"}}>
                {
                    seminardata?.length > 0 ? (
                        filteredSeminars?.length > 0 ? (
                            filteredSeminars?.map((seminarObj, index) => (
                                <SeminarCard
                                    key={seminarObj.seminarId ?? index}
                                    seminarObj={seminarObj}
                                    pastSeminar={props.pastSeminar}
                                    showLess={showLess}
                                    readMoreProfile={readMoreProfile}
                                    onToggleStatus={toggledatafun}
                                    onEdit={EditDataSendToSeminar}
                                    onCopySubtenant={copysubtenant}
                                    onCopySubtenants={copysubtenants}
                                    onShowQr={handleShow}
                                    onShowFullProfile={showFullProfile}
                                    onShowLess={() => setShowLess(false)}
                                    filterSpeakerDescriptionLegth={filterSpeakerDescriptionLegth}
                                />
                            ))
                        ) : (
                            <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                                <h4>Seminar not available</h4>
                            </div>
                        )
                    ) : (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                            <h4>Seminar not available</h4>
                        </div>
                    )
                }


            </div>

            <Modal show={show} onHide={handleClose} enforceFocus={false} centered size="md">
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontSize: "15px", color: "#333333", fontWeight: 600 }}>QR Code</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='d-flex flex-column justify-content-center align-items-center' id='qr-gen' style={{ padding: "10px 0" }}>
                        <QRCode
                            size={180}
                            style={{ height: "180px", width: "180px" }}
                            value={NewStatee}
                            viewBox={`0 0 256 256`}
                        />
                        <p style={{ marginTop: "12px", fontSize: "14px", color: "#333", textAlign: "center", marginBottom: 0 }}>
                            Scan the QR code to open the event details page
                        </p>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
export default PublishedSeminar